import { render, staticRenderFns } from "./WireTransferList.vue?vue&type=template&id=7d1a4b04&scoped=true&"
import script from "./WireTransferList.vue?vue&type=script&lang=js&"
export * from "./WireTransferList.vue?vue&type=script&lang=js&"
import style0 from "./WireTransferList.vue?vue&type=style&index=0&id=7d1a4b04&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1a4b04",
  null
  
)

export default component.exports